import { customConfig } from './custom';

const baseConfig = {
    absenceReport: false,
    admission: false,
    allowChangeRateFirst: false,
    allowGlobalCallRates: false,
    allowHTTP: false,
    allowPatientChangePassword: true,
    apiUrl: 'https://dev-mol-backend.medicosonline.app/api',
    appointmentTypeSpecialties: false,
    appointmentTypes: true,
    areas: false,
    asyncConsults: false,
    auditPatient: true,
    availableLanguages: ['es'],
    billing: false,
    blockedWeekDays: [],
    callTimerSeconds: 120,
    campaigns: false,
    chatbot: false,
    company: false,
    consult: true,
    controls: false,
    costCenters: false,
    coverages: true,
    dashboardEvolutions: false,
    dashboardInitialLoad: 20,
    db: '',
    defaultLanguage: 'es',
    defaultPhone: {
        code: '+54',
        country: 'ar'
    },
    diagnosisAudits: false,
    diagnosisDetailedInformation: false,
    diagnosisLicense: false,
    diagnosisShowReasons: false,
    doctorsRelated: false,
    documentTitle: 'MOL - Admin',
    enrollmentSpecialty: false,
    entity: true,
    environment: 'dev-mol-admin',
    errorBoundary: true,
    errorTrace: true,
    extendedPatientHistory: false,
    externalService: false,
    files: false,
    hideEvolutionColumns: false,
    hideStatistics: {
        absenteeism: true,
        administration: false,
        diagnostics: false,
        general: false,
        licenses: true,
        professionals: false,
        recommendations: false,
        sessions: false,
        statistics: false,
        surveys: false,
        symptoms: false,
        turns: true,
        videocall: false
    },
    identificationFreeLength: false,
    identificationOptions: ['DNI'],
    inCallHoursDisconnection: 3,
    interconsult: true,
    language: 'DEFAULT',
    offices: true,
    orderCreation: false,
    patientHistoryRegistration: false,
    patientIdentificationAlpha: false,
    patientImport: false,
    patientImportOffice: false,
    patientListing: false,
    patientMinimumFields: false,
    patientProfile: false,
    patientRegistration: false,
    platformPayment: false,
    polyOffices: false,
    positions: false,
    prework: false,
    professionalAllowExternal: true,
    professionalBio: false,
    professionalCallRate: false,
    professionalCoverageSelection: false,
    professionalLocation: true,
    professionalLockedActions: false,
    professionalStatus: true,
    recipes: false,
    recipesFiles: false,
    recipesRequests: false,
    recording: false,
    redirectAfterLogin: undefined,
    restrictedMenu: [],
    riskAgents: false,
    roomTimeAvailability: true,
    showPatientTurnaroundTime: false,
    showPatientWaitingDuration: false,
    socketPrefix: '',
    socketUrl: 'https://dev-mol-backend.medicosonline.app',
    specialtyPin: false,
    ssoLogin: false,
    sysAdmins: ['admin@mol.com', 'token@mol.com'],
    termsAndConditionsVersion: '0',
    turnOvershift: true,
    turnTypes: ['presential', 'online'],
    turnTypesLabels: ['Presencial', 'Online'],
    turns: false,
    turnsCoverage: false,
    turnsEdit: true,
    turnsPatientCreation: true,
    turnsPayment: false,
    turnsPresentialFlow: false,
    urlAdmin: '',
    urlPatient: '',
    urlProfessional: '',
    version: '113.2',
    videoconference: false,
    workplaces: false
};

export const config = { ...baseConfig, ...customConfig };
